export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc',
}

export const sortedValues: SortOrder[] = [SortOrder.Asc, SortOrder.Desc];

export const getSortIndexValue = (sortOrder: SortOrder): number => {
  return sortedValues.findIndex((value) => value === sortOrder);
};

export const getSortIcon = (sortOrder: SortOrder) => {
  return sortOrder === SortOrder.Desc
    ? 'common/assets/icons/sort_Z-A.svg'
    : 'common/assets/icons/sort_A-Z.svg';
};

export const getSortedList = (
  list: unknown[],
  sortOrder: SortOrder,
  sortField = 'name',
  sortedFieldType = 'string',
) => {
  if (sortedFieldType === 'number') {
    return sortOrder === SortOrder.Desc
      ? list.sort((a: any, b: any) => b[sortField] - a[sortField])
      : list.sort((a: any, b: any) => a[sortField] - b[sortField]);
  }
  return sortOrder === SortOrder.Desc
    ? list.sort((a: any, b: any) => b[sortField].localeCompare(a[sortField]))
    : list.sort((a: any, b: any) => a[sortField].localeCompare(b[sortField]));
};

export const getFilteredList = <T>(
  list: T[],
  searchValue: string | null = '',
  searchedFields: string[] = [],
): T[] => {
  if (!searchValue) {
    return list;
  }
  const query = searchValue.toString().toLowerCase();
  return list.filter((o: any) =>
    [...searchedFields, 'name'].some((key) => o[key]?.toString().toLowerCase().includes(query)),
  );
};

export const getSearchSortValue = (
  list: any,
  searchValue: string | null = '',
  sortOrder: SortOrder,
  searchedFields: string[] = [],
  sortedField = 'name',
  sortedFieldType = 'string',
) => {
  return getSortedList(
    getFilteredList(list, searchValue, searchedFields),
    sortOrder,
    sortedField,
    sortedFieldType,
  );
};
